import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import classnames from 'classnames';
import type { ChangeEvent, FocusEvent, KeyboardEvent, ReactNode } from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from 'atoms/icons';
import { laptopAndAbove } from 'style/mediaQuery';

import { TextInput } from '../TextInput';

type Props = {
  rounded?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  placeholder?: string;
  fullWidth?: boolean;
  withIcon?: boolean;
  largeFont?: boolean;
  inputRef?: any;
  autoFocus?: boolean;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  endAdornment?: ReactNode;
  small?: boolean;
  name?: string;
};

const Root = styled(TextInput)`
  /* https://thingsthemselves.com/no-input-zoom-in-safari-on-iphone-the-pixel-perfect-way/ */
  font-size: 16px;
  @media ${laptopAndAbove} {
    font-size: 15px;
  }
  &.fullWidth {
    width: 100%;
  }
  &.small {
    height: var(--quadruple-unit);
  }
`;

const SearchIcon = () => {
  return <FontAwesomeIcon icon={faSearch} />;
};

export const SearchInput = ({
  value,
  fullWidth = false,
  withIcon = false,
  endAdornment,
  inputRef,
  small = false,
  ...inputProps
}: Props) => {
  return (
    <Root
      value={value}
      className={classnames({ small, fullWidth })}
      inputRef={inputRef}
      autoCorrect="off"
      autoComplete="off"
      startAdornment={withIcon ? <SearchIcon /> : null}
      type="search"
      endAdornment={endAdornment}
      {...inputProps}
    />
  );
};

SearchInput.displayName = 'SearchInput';
